export const messages = {
  en: {
    activitiesSignUpManage: {
      search: {
        title: 'Search Conditions',
        activitiesId: 'Please enter activity ID',
        activitiesTitle: 'Please enter activity title',
        titlePlaceholder: 'Please enter title',
        typeCd: 'Please select activity type',
        staffName: 'Please enter publisher name',
        startTime: 'Please enter start time',
        endTime: 'Please enter end time'
      },
      list: {
        title: 'Activity List'
      },
      table: {
        signUpId:'Sign Up ID',
        activitiesId: 'Activity ID',
        activitiesTitle: 'Activity Title',
          userName: 'User Name',
          userTel:'User Tel',
          peopleCount:'People Count',
          payAmount:'Pay Amount',
          stateName:'State Name',
          createTime: 'Create Time'
      },
      add: {
        title: 'Add Activity',
        titlePlaceholder: 'Required, please enter title',
        typeCd: 'Activity Type',
        startTime: 'start time',
        endTime: 'end time',
        signUpStartTime: 'sign up start time',
        signUpEndTime: 'sign up end time',
        typeCdPlaceholder: 'Required, please select type',
        isMoreCommunity: 'Multi-community',
        isMoreCommunityPlaceholder: 'Please select if multi-community',
        headerImg: 'Header Image (800*595)',
        startTimePlaceholder: 'Required, please enter start time',
        endTimePlaceholder: 'Required, please enter end time',
        context: 'Content'
      },
      edit: {
        title: 'Edit Activity',
        titlePlaceholder: 'Required, please enter title',
        typeCd: 'Activity Type',
        startTime: 'start time',
        endTime: 'end time',
        signUpStartTime: 'sign up start time',
        signUpEndTime: 'sign up end time',
        typeCdPlaceholder: 'Required, please select type',
        headerImg: 'Header Image (800*595)',
        startTimePlaceholder: 'Required, please enter start time',
        endTimePlaceholder: 'Required, please enter end time',
        context: 'Content',
        userName: 'User Name',
        userTel: 'User Tel',
        peopleCount: 'People Count',
        state: 'Status',
        userNamePlaceholder: 'Required, please enter user name',
        userTelPlaceholder: 'Required, please enter user phone',
        peopleCountPlaceholder: 'Required, please enter number of people',
        statePlaceholder: 'Please select status'
      },
      detail: {
        title: 'Sign Up Detail',
        personList: 'Participant List',
        personName: 'Name',
        personTel: 'Phone',
        idCard: 'ID Card',
        index: 'No.',
        remark: 'Remark'
      },
      delete: {
        title: 'Confirm Operation',
        confirmText: 'Are you sure to delete this data?'
      },
      validate: {
        titleRequired: 'Title is required',
        titleMaxLength: 'Title cannot exceed 200 characters',
        typeCdRequired: 'Type is required',
        headerImgRequired: 'Header image is required',
        contextRequired: 'Content is required',
        startTimeRequired: 'Start time is required',
        endTimeRequired: 'End time is required',
        signUpStartTimeRequired: 'Sign up start time is required',
        signUpEndTimeRequired: 'Sign up end time is required',
        activitiesIdRequired: 'Activity ID is required',
        imageSize: 'Image size cannot exceed 2MB',
        userNameRequired: 'User name is required',
        userNameMaxLength: 'User name cannot exceed 50 characters',
        userTelRequired: 'Phone number is required',
        userTelFormat: 'Invalid phone number format',
        peopleCountRequired: 'Number of people is required',
        peopleCountMin: 'Number of people must be at least 1',
        stateRequired: 'Status is required'
      }
    }
  },
  zh: {
    activitiesSignUpManage: {
      search: {
        title: '活动报名查询',
        activitiesId: '请输入活动ID',
        activitiesTitle: '请输入活动标题',
          userName:'请输入姓名',
          userTel:'请输入电话',
          state:'请选择报名状态',
        titlePlaceholder: '请输入标题',
        typeCd: '请选择活动类型',
        staffName: '请输入发布人名称',
        startTime: '请输入开始时间',
        endTime: '请输入结束时间'
      },
      list: {
        title: '活动报名列表'
      },
      table: {
        signUpId:'报名ID',
        activitiesId: '活动ID',
        activitiesTitle: '活动标题',
          userName: '姓名',
          userTel:'电话',
          peopleCount:'人数',
          payAmount:'缴费金额',
          stateName:'状态',
          createTime: '报名时间'
      },
      add: {
        title: '添加活动',
        titlePlaceholder: '必填，请输入标题',
        typeCd: '类型',
        startTime: '开始时间',
        endTime: '结束时间',
        typeCdPlaceholder: '必填，请选择类型',
        isMoreCommunity: '多小区',
        isMoreCommunityPlaceholder: '请选择是否多小区',
        headerImg: '头图(800*595)',
        startTimePlaceholder: '必填，请输入开始时间',
        endTimePlaceholder: '必填，请输入结束时间',
        context: '内容',
        signUpStartTime: '报名开始时间',
        signUpEndTime: '报名结束时间',
        signUpStartTimePlaceholder: '必填，请输入报名开始时间',
        signUpEndTimePlaceholder: '必填，请输入报名结束时间',
      },
      edit: {
        title: '编辑活动',
        titlePlaceholder: '必填，请输入标题',
        typeCd: '类型',
        typeCdPlaceholder: '必填，请选择类型',
        headerImg: '头图(800*595)',
        startTimePlaceholder: '必填，请输入开始时间',
        endTimePlaceholder: '必填，请输入结束时间',
        startTime: '开始时间',
        endTime: '结束时间',
        context: '内容',
        signUpStartTime: '报名开始时间',
        signUpEndTime: '报名结束时间',
        signUpStartTimePlaceholder: '必填，请输入报名开始时间',
        signUpEndTimePlaceholder: '必填，请输入报名结束时间',
        userName: '姓名',
        userTel: '电话',
        peopleCount: '人数',
        state: '状态',
        userNamePlaceholder: '必填，请输入姓名',
        userTelPlaceholder: '必填，请输入电话',
        peopleCountPlaceholder: '必填，请输入人数',
        statePlaceholder: '请选择状态'
      },
      detail: {
        title: '报名详情',
        personList: '参加人员信息',
        personName: '姓名',
        personTel: '手机号',
        idCard: '身份证',
        index: '序号',
        remark: '备注'
      },
      delete: {
        title: '确认操作',
        confirmText: '确认删除该报名吗？'
      },
      validate: {
        titleRequired: '标题不能为空',
        titleMaxLength: '标题不能超过200个字符',
        typeCdRequired: '类型不能为空',
        headerImgRequired: '头部照片不能为空',
        contextRequired: '内容不能为空',
        startTimeRequired: '开始时间不能为空',
        endTimeRequired: '结束时间不能为空',
        signUpStartTimeRequired: '报名开始时间不能为空',
        signUpEndTimeRequired: '报名结束时间不能为空',
        activitiesIdRequired: '活动ID不能为空',
        imageSize: '图片大小不能超过2MB',
        userNameRequired: '姓名不能为空',
        userNameMaxLength: '姓名不能超过50个字符',
        userTelRequired: '电话号码不能为空',
        userTelFormat: '电话号码格式不正确',
        peopleCountRequired: '人数不能为空',
        peopleCountMin: '人数必须至少为1',
        stateRequired: '状态不能为空'
      }
    }
  }
}